import React from "react";

export const MaterialsSummary = ({
  allMaterials,
  materialKeyMap,
  design,
  team,
}) => {
  if (!team.tierLimits.seePrices || !allMaterials) return null;

  const totalLength = allMaterials.totalLength || 0;

  // Calculate subtotal
  const subtotal = Object.entries(allMaterials)
    .filter(
      ([key]) =>
        ![
          "singleGates",
          "doubleGates",
          "gateExtensions",
          "totalLength",
        ].includes(key),
    )
    .reduce((sum, [materialKey, quantity]) => {
      const designMaterialKey = materialKeyMap[materialKey];
      const material = design.materials[designMaterialKey];
      if (!material || !material.included) return sum;

      // For mesh, use totalLength instead of quantity for price calculation
      const itemTotal =
        materialKey === "mesh"
          ? totalLength * material.price
          : quantity * material.price;

      return sum + itemTotal;
    }, 0);

  // Add gate costs to subtotal
  let gateSubtotal = 0;
  if (design.gate?.gate?.included) {
    gateSubtotal +=
      ((allMaterials.singleGates || 0) + (allMaterials.doubleGates || 0) * 2) *
      design.gate.gate.price;
  }
  if (allMaterials.singleGates > 0 && design.gate?.singleGateKit?.included) {
    gateSubtotal += allMaterials.singleGates * design.gate.singleGateKit.price;
  }
  if (allMaterials.doubleGates > 0 && design.gate?.doubleGateKit?.included) {
    gateSubtotal += allMaterials.doubleGates * design.gate.doubleGateKit.price;
  }
  if (allMaterials.gateExtensions > 0 && design.gate?.gateExtension?.included) {
    gateSubtotal +=
      allMaterials.gateExtensions * design.gate.gateExtension.price;
  }

  const totalSubtotal = subtotal + gateSubtotal;
  const taxAmount = totalSubtotal * (team.team.materialTax / 100);
  const totalWithTax = totalSubtotal + taxAmount;

  return (
    <>
      {/* Subtotal Row */}
      <div className="p-4 md:grid md:grid-cols-5 md:items-center bg-gray-100 border-t-2 border-gray-300">
        <div className="col-span-4 flex justify-between md:justify-end items-center">
          <p className="text-base md:text-lg font-semibold">Subtotal:</p>
        </div>
        <p className="text-lg md:text-xl font-bold text-blue-600 text-right md:text-left mt-1 md:mt-0">
          ${totalSubtotal.toFixed(2)}
        </p>
      </div>

      {/* Tax Row */}
      <div className="p-4 md:grid md:grid-cols-5 md:items-center bg-gray-100 border-t border-gray-300">
        <div className="col-span-4 flex justify-between md:justify-end items-center">
          <p className="text-base md:text-lg">
            Tax ({team.team.materialTax}%):
          </p>
        </div>
        <p className="text-lg md:text-xl font-semibold text-right md:text-left mt-1 md:mt-0">
          ${taxAmount.toFixed(2)}
        </p>
      </div>

      {/* Total Row */}
      <div className="p-4 md:grid md:grid-cols-5 md:items-center bg-gray-200 border-t border-gray-400 rounded-b-lg">
        <div className="col-span-4 flex justify-between md:justify-end items-center">
          <p className="text-lg md:text-xl font-bold">Total:</p>
        </div>
        <p className="text-xl md:text-2xl font-bold text-blue-700 text-right md:text-left mt-1 md:mt-0">
          ${totalWithTax.toFixed(2)}
        </p>
      </div>
    </>
  );
};
